export { PieChart3 as default } from './PieChart3';
